export const MEGABYTES = 1024 * 1024
export const MAX_FILE_SIZE = 10 * MEGABYTES
